<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title: string
    text?: string
    required?: boolean
    windowInnerWidth?: number,
    rowContentClass?: string
  }>(),
  {
    rowContentClass: ''
  }
)

</script>
<template>
  <v-row class="text-form pl-4 pr-3 d-flex align-center">
    <v-col
      :cols="props.windowInnerWidth && props.windowInnerWidth > 800 ? 2 : 3"
    >
      <h6 class="pt-2 pl-4">
        {{ props.title }}<span v-show="props.required" style="color: red">✴︎</span>
      </h6>
    </v-col>
    <v-col
      :cols="props.windowInnerWidth && props.windowInnerWidth > 800 ? 10 : 9"
      :class="props.rowContentClass"
      style="position: relative"
    >
      <slot></slot>
    </v-col>
  </v-row>
</template>